import React, { Fragment, useEffect, useState } from 'react'

// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faFileImport,
    faCalendarAlt,
    faBuilding,
    faFileExcel,
    faBoxes,
    faChartBar,
} from '@fortawesome/free-solid-svg-icons'

// charts
import { Doughnut, Bar } from '@reactchartjs/react-chart.js'

// components
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'
import Header from '../Header/Header'

// route
import { withRouter } from 'react-router-dom'

// services
import { getAllProveedores } from '../../Services/proveedorService'
import { getAllSucursales } from '../../Services/sucursalService'
import {
    getReporteCompraResumen,
    getReporteCompraDeudasProveedor,
    getReporteCompraArticulos,
    getReporteCompraDetalle,
} from '../../Services/informesService'
import { getExcelReporteCompra } from '../../Services/reporteService'

// utils
import { formatFechaArgentina } from '../../utils/fechaArgentina'

// alert swal
import Swal from 'sweetalert2'

const ESTADO_LABELS = {
    PAGADA: 'Pagada',
    ADEUDADA: 'Adeudada',
    PAGADA_PARCIALMENTE: 'Pagada parcialmente',
}

const CHART_BG = [
    'rgba(255, 99, 132, 0.2)',
    'rgba(54, 162, 235, 0.2)',
    'rgba(255, 206, 86, 0.2)',
    'rgba(75, 192, 192, 0.2)',
    'rgba(153, 102, 255, 0.2)',
    'rgba(255, 159, 64, 0.2)',
]

const CHART_BORDER = [
    'rgba(255, 99, 132, 1)',
    'rgba(54, 162, 235, 1)',
    'rgba(255, 206, 86, 1)',
    'rgba(75, 192, 192, 1)',
    'rgba(153, 102, 255, 1)',
    'rgba(255, 159, 64, 1)',
]

const InformeCompras = ({ history }) => {
    let token = JSON.parse(atob(sessionStorage.getItem('token').split('.')[1]))
    let rol = token.authorities[0]

    const FormatDate = (date) => {
        let day = date.getDate()
        let month = date.getMonth() + 1
        let year = date.getFullYear()

        if (month < 10) month = '0' + month
        if (day < 10) day = '0' + day

        return year + '-' + month + '-' + day
    }

    const [isLoad, setIsLoad] = useState(true)
    const [sucursales, setSucursales] = useState([])
    const [sucursal, setSucursal] = useState(token.sucursal.id)
    const [proveedores, setProveedores] = useState([])
    const [proveedor, setProveedor] = useState('')
    const [fechaDesde, setFechaDesde] = useState(FormatDate(new Date()))
    const [fechaHasta, setFechaHasta] = useState(FormatDate(new Date()))

    const [porEstado, setPorEstado] = useState([])
    const [deudas, setDeudas] = useState([])
    const [totalCount, setTotalCount] = useState(0)
    const [totalMonto, setTotalMonto] = useState(0)
    const [dataEstado, setDataEstado] = useState({})
    const [dataDeudas, setDataDeudas] = useState({})
    const [hasGenerated, setHasGenerated] = useState(false)

    useEffect(() => {
        if (rol !== 'ROLE_ADMIN') history.goBack()
        if (isLoad) {
            getAllSucursales(true, 0, '', 1000)
                .then((res) => {
                    setSucursales(res.data.content)
                })
                .catch((error) => {
                    console.log(error)
                })
            getAllProveedores(true, 0, '', 1000)
                .then((res) => {
                    setProveedores(res.data.content)
                })
                .catch((error) => {
                    console.log(error)
                })
            setIsLoad(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoad])

    const requireFilters = () => {
        if (!fechaDesde || !fechaHasta || !sucursal) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'Desde, hasta y sucursal son obligatorios',
                type: 'warning',
                showConfirmButton: false,
                timer: 1800,
            })
            return false
        }
        return true
    }

    const proveedorFilter = () => (proveedor ? proveedor : undefined)

    const buildEstadoChart = (estados) => {
        const labels = estados.map(
            (item) => ESTADO_LABELS[item.estado] || item.estado
        )
        const data = estados.map((item) =>
            Number.parseFloat(item.monto || 0).toFixed(2)
        )
        setDataEstado({
            labels,
            datasets: [
                {
                    label: 'Total Compras por estado',
                    data,
                    backgroundColor: CHART_BG.slice(0, labels.length),
                    borderColor: CHART_BORDER.slice(0, labels.length),
                    borderWidth: 1,
                },
            ],
        })
    }

    const buildDeudasChart = (rows) => {
        const labels = rows.map((item) => item.proveedorNombre)
        const data = rows.map((item) =>
            Number.parseFloat(item.deuda || 0).toFixed(2)
        )
        setDataDeudas({
            labels,
            datasets: [
                {
                    label: 'Total deudas por proveedor',
                    data,
                    backgroundColor: CHART_BG,
                    borderColor: CHART_BORDER,
                    borderWidth: 1,
                },
            ],
        })
    }

    const handleGenerarInforme = async () => {
        if (!requireFilters()) return

        try {
            const proveedorId = proveedorFilter()
            const [resumenRes, deudasRes] = await Promise.all([
                getReporteCompraResumen(
                    fechaDesde,
                    fechaHasta,
                    sucursal,
                    proveedorId
                ),
                getReporteCompraDeudasProveedor(
                    fechaDesde,
                    fechaHasta,
                    sucursal,
                    proveedorId
                ),
            ])

            const resumen = resumenRes.data
            const deudasRows = deudasRes.data || []

            setPorEstado(resumen.porEstado || [])
            setDeudas(deudasRows)
            setTotalCount(resumen.totalCount || 0)
            setTotalMonto(resumen.totalMonto || 0)
            buildEstadoChart(resumen.porEstado || [])
            buildDeudasChart(deudasRows)
            setHasGenerated(true)
        } catch (error) {
            setHasGenerated(false)
            setTotalCount(0)
            setPorEstado([])
            setDeudas([])
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No se pudieron cargar los informes de compras',
                type: 'info',
                showConfirmButton: false,
                timer: 1500,
            })
        }
    }

    const handleExcelReporte = async () => {
        if (!requireFilters()) return
        if (!totalCount || totalCount === 0) return

        try {
            const proveedorId = proveedorFilter()
            const [articulosRes, detalleRes, resumenRes] = await Promise.all([
                getReporteCompraArticulos(
                    fechaDesde,
                    fechaHasta,
                    sucursal,
                    proveedorId
                ),
                getReporteCompraDetalle(
                    fechaDesde,
                    fechaHasta,
                    sucursal,
                    proveedorId
                ),
                getReporteCompraResumen(
                    fechaDesde,
                    fechaHasta,
                    sucursal,
                    proveedorId
                ),
            ])

            const excel = await getExcelReporteCompra(
                articulosRes.data,
                detalleRes.data,
                resumenRes.data.porEstado,
                null
            )

            const contenido = encodeURI(excel.data)
            let excelWindow = window.open('')
            excelWindow.document.write(
                `<iframe width='100%' height='100%' margin='0px' padding='0px' src='data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${contenido}'>
                </iframe>`
            )
            setTimeout(() => {
                excelWindow.close()
            }, 3000)
        } catch (error) {
            Swal.fire({
                title: 'No hay datos para estas fechas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
        }
    }

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo icon={faFileImport} title={'Informes Compras'} />
                </div>

                <div className="bg-gris p-3">
                    <div className="d-flex bd-highlight mb-3 flex-wrap">
                        <div className="p-2 bd-highlight">
                            <label htmlFor="inputFechaDesde">Desde *</label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                </span>
                                <input
                                    type="date"
                                    className="form-control"
                                    id="inputFechaDesde"
                                    name="fechaDesde"
                                    value={fechaDesde}
                                    onChange={(e) =>
                                        setFechaDesde(e.target.value)
                                    }
                                />
                            </div>
                        </div>
                        <div className="p-2 bd-highlight">
                            <label htmlFor="inputFechaHasta">Hasta *</label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                </span>
                                <input
                                    type="date"
                                    className="form-control"
                                    id="inputFechaHasta"
                                    value={fechaHasta}
                                    name="fechaHasta"
                                    onChange={(e) =>
                                        setFechaHasta(e.target.value)
                                    }
                                />
                            </div>
                        </div>
                        <div className="p-2 bd-highlight">
                            <label htmlFor="inputSucursal">Sucursal *</label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faBuilding} />
                                </span>
                                <select
                                    id="inputSucursal"
                                    className="custom-select"
                                    name="sucursal"
                                    value={sucursal}
                                    onChange={(e) =>
                                        setSucursal(e.target.value)
                                    }
                                >
                                    {sucursales.map((s, index) => (
                                        <option key={index} value={s.id}>
                                            {s.nombre}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="p-2 bd-highlight">
                            <label htmlFor="inputProveedor">Proveedor</label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faBoxes} />
                                </span>
                                <select
                                    id="inputProveedor"
                                    className="custom-select"
                                    name="proveedor"
                                    value={proveedor}
                                    onChange={(e) =>
                                        setProveedor(e.target.value)
                                    }
                                >
                                    <option value="">
                                        Seleccione un proveedor
                                    </option>
                                    {proveedores.map((p, index) => (
                                        <option key={index} value={p.id}>
                                            {p.nombre}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div
                            className="ms-auto p-2 bd-highlight"
                            style={{ marginTop: 20 }}
                        >
                            <button
                                className="btn btn-outline-info btn-lg mr-2"
                                onClick={handleGenerarInforme}
                            >
                                <FontAwesomeIcon icon={faChartBar} /> Generar
                                Reporte
                            </button>
                            <button
                                className="btn btn-outline-success btn-lg"
                                onClick={handleExcelReporte}
                                disabled={!hasGenerated || totalCount === 0}
                                title={
                                    !hasGenerated
                                        ? 'Generá el reporte primero'
                                        : totalCount === 0
                                          ? 'Sin datos para exportar'
                                          : 'Exportar Excel'
                                }
                            >
                                <FontAwesomeIcon icon={faFileExcel} /> Excel
                            </button>
                        </div>
                    </div>
                    {hasGenerated && (
                        <p className="mb-0 text-muted">
                            Período:{' '}
                            {formatFechaArgentina(fechaDesde)} —{' '}
                            {formatFechaArgentina(fechaHasta)} · Total: $
                            {Number.parseFloat(totalMonto || 0).toFixed(2)} (
                            {totalCount} compras)
                        </p>
                    )}
                </div>

                {hasGenerated && (
                    <Fragment>
                        <br />
                        <div className="bg-gris p-3 justify-content-center">
                            <h5 className="mb-3">Total Compras por estado</h5>
                            <div className="row">
                                <div className="col-6">
                                    <table className="table table-striped mt-3 text-center">
                                        <thead>
                                            <tr>
                                                <th scope="col">Estado</th>
                                                <th scope="col">Monto</th>
                                                <th scope="col">Cantidad</th>
                                                <th scope="col">
                                                    Monto pagado
                                                </th>
                                                <th scope="col">Restante</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {porEstado.map((item) => (
                                                <tr key={item.estado}>
                                                    <td>
                                                        {ESTADO_LABELS[
                                                            item.estado
                                                        ] || item.estado}
                                                    </td>
                                                    <td>
                                                        $
                                                        {Number.parseFloat(
                                                            item.monto || 0
                                                        ).toFixed(2)}
                                                    </td>
                                                    <td>{item.count || 0}</td>
                                                    <td>
                                                        {item.montoPagado !=
                                                        null
                                                            ? `$${Number.parseFloat(
                                                                  item.montoPagado
                                                              ).toFixed(2)}`
                                                            : '—'}
                                                    </td>
                                                    <td>
                                                        {item.montoRestante !=
                                                        null
                                                            ? `$${Number.parseFloat(
                                                                  item.montoRestante
                                                              ).toFixed(2)}`
                                                            : '—'}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-6">
                                    <Bar data={dataEstado} />
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className="bg-gris p-3">
                            <h5 className="mb-3">
                                Total deudas por proveedor
                            </h5>
                            <div className="row">
                                <div className="col-6">
                                    <table className="table table-striped mt-3 text-center">
                                        <thead>
                                            <tr>
                                                <th scope="col">Proveedor</th>
                                                <th scope="col">Deuda</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {deudas.length === 0 ? (
                                                <tr>
                                                    <td colSpan={2}>
                                                        Sin deudas en el
                                                        período
                                                    </td>
                                                </tr>
                                            ) : (
                                                deudas.map((item, index) => (
                                                    <tr
                                                        key={`${item.proveedorNombre}-${index}`}
                                                    >
                                                        <td>
                                                            {
                                                                item.proveedorNombre
                                                            }
                                                        </td>
                                                        <td>
                                                            $
                                                            {Number.parseFloat(
                                                                item.deuda || 0
                                                            ).toFixed(2)}
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-6">
                                    {deudas.length > 0 ? (
                                        <Doughnut data={dataDeudas} />
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </Fragment>
                )}
            </div>
        </Fragment>
    )
}

export default withRouter(InformeCompras)
